/**
 * Copyright (C) 2021 THL A29 Limited, a Tencent company.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import Toolbar from './Toolbar';
/**
 * 预览区域右侧悬浮的工具栏
 * 推荐放置跟编辑区域完全无关的工具栏
 *    比如复制预览区域内容、修改预览区域主题等
 */
export default class Sidebar extends Toolbar {
  // constructor(options) {
  //   super(options);
  // }
  appendMenusToDom(menus) {
    this.options.dom.appendChild(menus);
  }
}
